/**
 * Handles file upload + metadata + analysis trigger.
 * Returns { docId, result } where result is the analysis payload from the cloud function.
 */
import { saveFileMetaToFirestore, uploadFileToStorage } from "../services"

const useAnalysisUpload = ({ user, setDocumentId }) => {
  const uploadAndAnalyze = async (file) => {
    let uniqueFileName = null
    let storageUrl = null

    const result = await uploadFileToStorage(user.uid, file)
    storageUrl = result.url
    uniqueFileName = result.uniqueFileName

    const extension = file.name.split(".").pop().toLowerCase()
    const size = file.size

    const doc = await saveFileMetaToFirestore({
      userId: user.uid,
      fileName: file.name,
      uniqueFileName,
      storageUrl,
      extension,
      size,
      status: "pending",
      errorMessage: null,
    })
    setDocumentId?.(doc.id)
    const res = await fetch("https://analyzedocument-ebgvzpp3na-uc.a.run.app", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ documentId: doc.id }),
    })

    if (!res.ok) {
      throw new Error("Failed to fetch contract analysis")
    }

    const data = await res.json()
    const resultData = { ...data?.result, documentId: doc.id }

    return { docId: doc.id, result: resultData }
  }

  return { uploadAndAnalyze }
}

export default useAnalysisUpload
